import React from "react";
import {
  Card,
  CardActions,
  CardMedia,
  CardTitle,
  CardText
} from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";
import "./About.css";
import jc from "../../images/jc.jpg";
import igloo from "../../images/igloo.jpg";
import drawing2 from "../../images/drawing02.jpg";

const About = () => {
  return (
    <div id="about" className="about packages">
    <section>
      <h3 className="title">About Juan Carlos</h3>
      <img id="jc-img" src={jc} alt="juan carlos" />
      <p>I bring together insights from the fields of education, health and systems theory. I seek patterns in complexity. Those patterns tend to be where the challenges and solutions lie.</p>
      <p>I am a mix of various cultures and perspectives. Born and raised in balmy Guatemala, my formative years were an immersion into brilliant contrast of textures, emotions and experiences: civil strife, poverty, wealth; tropical rain forests and polluted urban environments. My early teen years placed my family and me in the small town of Ashland, Oregon, where puberty developed against a backdrop of Shakespearean plays, small-town politics, identity-crisis, and deep friendships. From my late 20’s to the present the Bay Area of San Francisco has been the platform for my development in career paths, personal journeys and deepening community ties.</p>
    <hr></hr>

    <ul className="grid">
      <h3 className="title">Some areas I do well in:</h3>
      <li>
        <i className="fa fa-compass fa-4x"></i>
        <h4>Seeing patterns in complexity</h4>
        <p>I like to connect the dots.</p>
      </li>
      <li>
        <i className="fa fa-camera-retro fa-4x"></i>
        <h4>Helping others</h4>
        <p>I like to learn and teach. </p>
      </li>
      <li>
        <i className="fa fa-bicycle fa-4x"></i>
        <h4>Innovation</h4>
        <p>Thinking outside the box.</p>
      </li>
      <li>
        <i className="fa fa-flag-checkered fa-4x"></i>
        <h4>Communicating ideas</h4>
        <p>I like sharing ideas and public speaking.</p>
      </li>
    </ul>
    <p>
      When I am not coding and innovating with others, you can find me
      hiking and making igloos in Yosemite, or drawing and illustrating.
    </p>
  </section>

      <div className="card-box2">
        <div className="card-grid2">
          <Card id="igloo-card">
            <CardMedia
              overlay={<CardTitle title="Making an Igloo in Yosemite" />}>
              <img id="igloo-image" src={igloo} alt="igloo" />
            </CardMedia>
            <CardText>
              Imagine you hiked out of Yosemite valley with two or three
              friends. It is a sunny day. Distant mountains are shrouded in
              clouds. Your packs hold all you will need for the next week. There
              is snow on the ground. Across the valley is Half Dome. You begin
              to build an igloo. You are cutting snow blocks. Each block is
              placed in a circle that slowly becomes your protective, cozy home
              for the next few days. You feel connected, free, safe and happy.
            </CardText>
            <CardActions>
              <RaisedButton
                href="https://get.google.com/albumarchive/108048564380821192433/album/AF1QipPrSdOhc5S345kL5hADnHdZpxuytxOMLW29yfG_"
                target="_blank"
                label="Eagle's Peak"
              />
            </CardActions>
          </Card>

          <Card id="drawing-card">
            <CardMedia overlay={<CardTitle title="Drawings and Photos" />}>
              <img src={drawing2} alt="" />
            </CardMedia>
            <CardText>Behance portfolio of my personal stuff.</CardText>
            <CardActions>
              <RaisedButton
                href="https://www.behance.net/copue"
                target="_blank"
                label="Behance"
              />
            </CardActions>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.js